import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { ActivatedRoute } from '@angular/router';
import { SelectedArea } from 'src/app/shared/area-select.component';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-camisa-trieur-card-III',
    templateUrl: './camisa-trieur-card-III.component.html'
})

export class CamisaTrieurCardIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    public listLinha?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTagTrieur?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listCamisa?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFracaoEnviada?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected route: ActivatedRoute, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Sugestão de Camisas (Uberlândia)', false);
        if (this.areaSelect === SelectedArea.Comercial) {
            this.formulario = this.formBuilder.group({
                linha: [null, [Validators.required]],
                peneira: [null, [Validators.required]],
                tag_trieur: [null, [Validators.required]],
                camisa: [null, [Validators.required]],
                fracao_enviada_silo: [null, [Validators.required]],
            });

        }

    }


    public async ngOnInit(): Promise<void> {
        Promise.all([
            this.getListLinha(),
            this.getListPeneira(),
            this.getListCamisa(),
            this.getListTagTrieur(),
            this.getListFracaoEnviada()
        ])
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getListLinha(): Promise<void> {
        await this.formularioService
            .getListDropDownList('camisa_trieur', 'linha')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listLinha = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }


    async getListCamisa(): Promise<void> {
        await this.formularioService
            .getListDropDownList('camisa_trieur', 'camisa')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listCamisa = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }


    async getListTagTrieur(): Promise<void> {
        await this.formularioService
            .getListDropDownList('camisa_trieur', 'tag_trieur')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listTagTrieur = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }

    async getListFracaoEnviada(): Promise<void> {
        await this.formularioService
            .getListDropDownList('camisa_trieur', 'fracao_enviada_silo')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listFracaoEnviada = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }

    async getListPeneira(): Promise<void> {
        await this.formularioService
            .getListDropDownList('camisa_trieur', 'peneira')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listPeneira = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }
}

